// ── Analytics API (Backend V2) ──────────────────────────────
const BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:4000";

function getToken() {
  return localStorage.getItem("accessToken") || "";
}

// Track a page view (call this on every page load / route change)
export async function trackPageView(page, referrer) {
  try {
    await fetch(`${BASE}/api/analytics/pageview`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ page, referrer: referrer || document.referrer || "" }),
    });
  } catch {
    // silently ignore — never break the page for tracking
  }
}

// Track a WhatsApp button click
export async function trackWaClick(page) {
  try {
    await fetch(`${BASE}/api/analytics/wa-click`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ page }),
    });
  } catch {
    // silently ignore
  }
}

// Get dashboard analytics data (admin, with optional date range)
export async function fetchAnalyticsDashboard(from, to) {
  const token = getToken();
  const params = new URLSearchParams();
  if (from) params.set("from", from);
  if (to) params.set("to", to);
  const qs = params.toString() ? `?${params.toString()}` : "";

  const response = await fetch(`${BASE}/api/analytics/dashboard${qs}`, {
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
  if (!response.ok) throw new Error("Failed to fetch analytics");
  return response.json();
}
